/** @jsxImportSource @emotion/react */
import React from "react";
import { Button } from "../../../general/Button/Button";
import { css } from "@emotion/react";

export const ConfirmButton: React.FC<{
  onClick: () => void;
  isVisible?: boolean;
  text: string;
  confirm?: boolean;
}> = ({ onClick, isVisible = true, text, confirm }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <Button
      text={text}
      textSize="Large"
      buttonType="primary"
      buttonCss={css`
        width: 340px;
        border-radius: 14px;
        display: flex;
        padding: 19px 18px;
        justify-content: center;
        align-items: center;
        align-self: stretch;
      `}
      onClick={onClick}
    />
  );
};
